var mrOffset = 0;
var candidatsOffset = 0;
var programaOffset = 0;

function navs_onResize() {
    mrOffset = $('#carta').offset().top;
    candidatsOffset = $('#candidats').offset().top;
    programaOffset = $('#programa').offset().top;
}

function navs_onScroll() {
    var windowTop = $(window).scrollTop() + 150;

    if (windowTop < candidatsOffset) {
        if (!$('.nav-eleccions-2023').hasClass('nav-actual')) {
            $('.navigation').children().removeClass('nav-actual');
            $('.nav-eleccions-2023').addClass('nav-actual');
        }
    }
    else if (windowTop > candidatsOffset && windowTop < (programaOffset + 200)) {
        if (!$('.nav-candidats').hasClass('nav-actual')) {
            $('.navigation').children().removeClass('nav-actual');
            $('.nav-candidats').addClass('nav-actual');
        }
    }
    else {
        if (!$('.nav-programa').hasClass('nav-actual')) {
            $('.navigation').children().removeClass('nav-actual');
            $('.nav-programa').addClass('nav-actual');
        }
    }
}

$(window).on('resize', function() {
    navs_onResize();
});

$(window).on('scroll', function() {
    navs_onScroll();
});

$(document).ready(function() {
    $('.nav-eleccions-2023').addClass('nav-actual');
    navs_onResize();
    navs_onScroll();
});
